import { render, staticRenderFns } from "./index.html?vue&type=template&id=ed55b716&"
import script from "./ImportQuestion.vue?vue&type=script&lang=js&"
export * from "./ImportQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ImportQuestion.vue?vue&type=style&index=0&id=ed55b716&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports